<template>
  <b-overlay
    v-if="total > 0 || user.userType == 'ADMIN'"
    :show="loader"
    rounded="sm"
    class="w-100"
  >
    <LocalizationProvider :language="kendoLang">
      <IntlProvider :locale="kendoLang">
        <!-- :groupable="false" -->
        <!-- :reorderable="false" -->
        <!-- :selectable="true" -->
        <!-- :group="group" -->
        <!-- :scrollable="'virtual'" -->
        <!-- :column-menu="false" -->
        <!-- :selected-field="selectedField" -->
        <Grid
          id="grid"
          ref="grid"
          :data-items="gridData"
          :resizable="true"
          :sortable="{ mode: 'multiple' }"
          :page-size="20"
          :sort="sort"
          @sortchange="sortChangeHandler"
          :filterable="false"
          :filter="null"
          @filterchange="filterChange"
          :pageable="true"
          :total="total"
          :take="take"
          :skip="skip"
          @pagechange="pageChangeHandler"
          :columns="columns"
          @rowclick="onRowClick"
        >
          <GridToolbar>
            <div class="grid-toolbar">
              <div class="grid-toggle-btns">
                <b-button
                  :variant="
                    currentBtn === 'Sourcing_Trend'
                      ? 'primary'
                      : 'outline-primary'
                  "
                  @click="onContentChange('Sourcing_Trend')"
                >
                  {{ $t("lbl_EMPBE_SourcingTrend") }}
                </b-button>

                <b-button
                  :variant="
                    currentBtn === 'Market_Analysis'
                      ? 'secondary'
                      : 'outline-secondary'
                  "
                  @click="onContentChange('Market_Analysis')"
                >
                  {{ $t("lbl_EMPBE_MarketAnalysis") }}
                </b-button>
              </div>

              <div class="grid-tool-btns">
                <div class="d-flex align-items-center">
                  <span class="m-r-5">
                    {{ this.$t("lbl_EMPBE_ShowDeletedRecord") }}
                  </span>
                  <div class="media-body icon-state">
                    <label class="switch mb-0">
                      <input type="checkbox" v-model="isShowDeleted" />
                      <span class="switch-state"></span>
                    </label>
                  </div>
                </div>

                <!-- v-bind:t_label="'EMPBE_News_btnAddNew'" -->
                <b-button
                  :variant="
                    currentBtn === 'Sourcing_Trend' ? 'primary' : 'secondary'
                  "
                  @click="onClickAdd"
                >
                  <i class="fa fa-plus-circle" style="line-height: 1.5" />
                  {{ this.$t("lbl_EMPBE_Add") }}
                </b-button>
              </div>
            </div>
          </GridToolbar>
          <!--Cell template-->

          <template v-slot:orderIdTemplate="{ props }">
            <td>
              <span>
                {{
                  props.dataItem.orderId === 999 /** No OrderId*/
                    ? "-"
                    : props.dataItem.orderId
                }}
              </span>
            </td>
          </template>

          <template v-slot:statusTemplate="{ props }">
            <td>
              <b-badge
                :variant="
                  props.dataItem.status === 'publish'
                    ? 'success'
                    : props.dataItem.status === 'unpublish'
                    ? 'info'
                    : 'light'
                "
              >
                {{ formatStatus(props.dataItem.status) }}
              </b-badge>
            </td>
          </template>

          <!--Cell template Ends-->
        </Grid>
      </IntlProvider>
    </LocalizationProvider>
  </b-overlay>
</template>

<script>
import {
  IntlProvider,
  // load,
  LocalizationProvider,
  // loadMessages,
} from "@progress/kendo-vue-intl";
import { Grid, GridToolbar } from "@progress/kendo-vue-grid";
// import { Input } from "@progress/kendo-vue-inputs";
// import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { process } from "@progress/kendo-data-query";
import { sourcingTrendService as service } from "@/_services";

export default {
  components: {
    Grid,
    GridToolbar,
    LocalizationProvider,
    IntlProvider,
    // KInput: Input,
    // DropDownList,
  },

  data() {
    return {
      currentBtn: "Sourcing_Trend", // "Sourcing_Trend" | "Market_Analysis"
      isShowDeleted: false,
      rawData: [],
      loader: true,
      group: [],
      sort: [
        { field: "orderId", dir: "asc" },
        { field: "status", dir: "desc" },
      ],
      total: 0,
      take: this.DEFAULT_TAKE,
      skip: this.DEFAULT_SKIP,
      // gridPageable: {
      //   info: true,
      //   pageSizes: false,
      // },
      _columns: [
        {
          field: "rid",
          title: "ID",
          width: "50px",
        },
        {
          field: "title",
          title: this.$t("lbl_EMPBE_Title"),
          width: "400px",
          // filterCell: "filterSlotTemplate",
        },
        {
          field: "status",
          title: this.$t("lbl_buyerform_status"),
          width: "140px",
          cell: "statusTemplate",
          // filterCell: "statusfilterSlotTemplate",
        },
        {
          field: "effectiveFrom",
          title: this.$t("lbl_EMPBE_PublishStart"),
          // cell: "effectiveFromDateTemplate",
          width: "180px",
          // filter: "date",
          // format: "{0:D}",
          // filterCell: "DatefilterSlotTemplate",
        },
        {
          field: "effectiveTo",
          title: this.$t("lbl_EMPBE_PublishEnd"),
          width: "180px",
          // filter: "date",
          // format: "{0:D}",
          // filterCell: "DatefilterSlotTemplate",
        },
        {
          field: "orderId",
          title: this.$t("Lbl_DisplayOrder"),
          width: "140px",
          cell: "orderIdTemplate",
          // filterCell: "statusfilterSlotTemplate",
        },
      ],
      get columns() {
        return this._columns;
      },
      set columns(value) {
        this._columns = value;
      },
      selectedField: "selected",
    };
  },

  mounted() {
    this.init();
  },

  created() {
    this.getData();
  },

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },

    // isAdmin() {
    //   return this.user.userType?.toUpperCase() === "ADMIN";
    // },

    // companyId() {
    //   return this.isAdmin ? 0 : this.user.empCompanyId;
    // },

    langId() {
      return localStorage.getItem("currentLangId");
    },

    kendoLang() {
      switch (this.langId) {
        case "1252":
          return "en-US";
        case "950":
          return "zh-Hant";
        case "936":
          return "zh-Hans";
        default:
          return "zh-Hans";
      }
    },

    gridData: {
      get: function () {
        const reportType = this.currentBtn;

        const localeSuffix =
          this.langId === "936"
            ? "_SC"
            : this.langId === "950"
            ? "_TC"
            : this.langId === "1252"
            ? "_EN"
            : "_SC";

        const titleKey = `title${localeSuffix}`;
        const urlLinkKey = `urlLink${localeSuffix}`;
        const imagePathKey = `imagePath${localeSuffix}`;

        // Mainly describe the data how to display in grid
        const filteredTypeData = this.rawData.filter(
          (x) => x.reportType === reportType
        );

        const filteredDataByDeleted = !this.isShowDeleted
          ? filteredTypeData.filter((x) => x.status !== "deleted")
          : filteredTypeData;

        const finalData = filteredDataByDeleted.map((content) => ({
          ...content,
          title: content[titleKey],
          urlLink: content[urlLinkKey],
          imagePath: content[imagePathKey],
          status: content.status,
          orderId: !!content.orderId ? content.orderId : 999,
          effectiveFrom: content.effectiveFrom
            ? this.formatDateString(content.effectiveFrom)
            : "",
          effectiveTo: content.effectiveTo
            ? this.formatDateString(content.effectiveTo)
            : "",
        }));

        this.total = finalData.length;

        return process(finalData, {
          take: this.take,
          skip: this.skip,
          filter: this.filter,
          sort: this.sort,
        });
      },
    },

    DEFAULT_TAKE: function () {
      return 20;
    },

    DEFAULT_SKIP: function () {
      return 0;
    },
  },

  methods: {
    init() {
      // Get Data From server
      this.getData();
    },

    getData() {
      var that = this;

      this.loader = true;

      service
        .LoadAllContents()
        .then((res) => {
          if (res.isSuccessful) {
            that.rawData = res?.data ?? [];

            // Map Raw data into table
            that.total = that.rawData?.length ?? 0;
          }
        })
        .finally(() => {
          that.loader = false;
        });
    },

    pageChangeHandler: function (event) {
      this.loader = true;

      this.skip = event.page.skip;
      this.take = event.page.take;

      this.loader = false;
    },

    sortChangeHandler: function (event) {
      this.loader = true;

      this.sort = event.sort;

      this.loader = false;
    },

    filterChange: function (event) {
      this.loader = true;

      this.filter = event.filter;

      this.loader = false;
    },

    onRowClick: function (event) {
      const type =
        this.currentBtn === "Sourcing_Trend"
          ? "SourcingTrend"
          : "MarketAnalysis";

      this.$router.push({
        name: "SourcingTrendAndMarketAnalysisDetail",
        params: {
          id: event.dataItem.rid,
          type,
        },
      });
    },

    onClickAdd() {
      const type =
        this.currentBtn === "Sourcing_Trend"
          ? "SourcingTrend"
          : "MarketAnalysis";

      this.$router.push({
        name: "SourcingTrendAndMarketAnalysisDetail",
        params: {
          id: 0,
          type,
        },
      });
    },

    onContentChange(content) {
      this.currentBtn = content;

      // Default setting when init
      this.skip = this.DEFAULT_SKIP;
      this.take = this.DEFAULT_TAKE;
    },

    formatDateString: function (dateString) {
      try {
        const date = new Date(dateString);
        const mm = date.getMonth() + 1; // getMonth() is zero-based
        const dd = date.getDate();

        return [
          date.getFullYear() + "-",
          (mm > 9 ? "" : "0") + mm + "-",
          (dd > 9 ? "" : "0") + dd,
        ].join("");
      } catch (ex) {
        console.log(ex);
        return "";
      }
    },

    formatStatus: function (status) {
      const mapping = {
        publish: "lbl_EMPBE_Publish",
        unpublish: "lbl_EMPBE_Unpublish",
        deleted: "lbl_EMPBE_Deleted",
      };

      return this.$t(mapping[status]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/grid";
</style>
